import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Merge conditional class names, de-duplicating conflicting Tailwind classes. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** "kr 2 355 297" — same nb-NO thousands formatting as kontor-vue's formatNok(). */
export function formatNok(n: number): string {
  return `kr ${Math.round(n).toLocaleString("nb-NO")}`;
}

/** "2026-04-15" → "15.04.2026" — same convention as kontor-vue's formatDate(). */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "–";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}.${m}.${y}`;
}

/** Up-to-two-letter initials from a name, e.g. "Ole Pedersen" → "OP". */
export function initialsOf(name?: string | null): string {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
